import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { LOG_OUT } from "../../redux/reducers/loginReducer";

export default function Logout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch({ type: LOG_OUT, payload: {}, history: navigate });
  }, [dispatch, navigate]);

  return <div className="centered"></div>;
}
